import { Price } from '../types'

export const formatPrice = ({ price, priceCurrency }: Price): string =>
  new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: priceCurrency,
    minimumFractionDigits: Number.isInteger(price) ? 0 : 2,
  }).format(price)
